import {
  CountryCode,
  DEFAULT_COUNTRY_CODE_LOWERCASE,
  LanguageCode,
  VALID_COUNTRY,
  VALID_LANGUAGE,
} from "@nf/constants";
import { getPrimaryLanguage } from "@nf/common/src/helpers/getPrimaryLanguage";

type LocaleSegment = string | string[] | undefined;

const normalizeSegment = (segment: LocaleSegment): string => {
  const value = Array.isArray(segment) ? segment[0] : segment;
  return value?.toLowerCase() ?? "";
};

export const isValidCountry = (country: LocaleSegment): boolean =>
  VALID_COUNTRY.includes(normalizeSegment(country) as Lowercase<CountryCode>);

export const isValidLanguage = (
  country: LocaleSegment,
  language: LocaleSegment
): boolean => {
  const languages =
    VALID_LANGUAGE[normalizeSegment(country) as Lowercase<CountryCode>];

  return !!languages?.includes(normalizeSegment(language) as LanguageCode);
};

export const resolveCountry = (country: LocaleSegment): string =>
  isValidCountry(country)
    ? normalizeSegment(country)
    : DEFAULT_COUNTRY_CODE_LOWERCASE;

export const resolveLanguage = (
  country: LocaleSegment,
  language: LocaleSegment
): string => {
  const resolvedCountry = resolveCountry(country);
  return isValidLanguage(resolvedCountry, language)
    ? normalizeSegment(language)
    : getPrimaryLanguage(resolvedCountry);
};
